import { FormField, Switch, UIText2, UIText3 } from '@cian/ui-kit';
import React, { useEffect } from 'react';

import { IField } from '../../types/calculator';
import { useBaseField } from '../BaseField';
import styles from './styles.css';

export const SwitchField: React.FC<IField> = props => {
  const { label, defaultValue, disabled, tooltip } = props;
  const {
    field: { onChange, name, value, ref },
    fieldState,
  } = useBaseField(props);

  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isError = fieldState.isDirty || fieldState.invalid;

  return (
    <FormField
      errorMessage={fieldState.isDirty ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.text}>
            <UIText2>{label}</UIText2>
            {tooltip && (
              <div className={styles.description}>
                <UIText3 color="text-secondary-default">{tooltip}</UIText3>
              </div>
            )}
          </div>
          <Switch
            data-testid={name}
            checked={Boolean(value)}
            onChange={(_, value) => onChange(value)}
            disabled={disabled}
            invalid={Boolean(isError && fieldState.error)}
            name={name}
            ref={ref}
          />
        </div>
      </div>
    </FormField>
  );
};

SwitchField.displayName = 'SwitchField';
